import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { withDevice } from '@blazar-plugins/device'

import { buildAdUrl } from 'utils/url'

import ListItem from './ListItem'
import getExtraProps from './getExtraProps'

const AdListItem = ({
  ad,
  device,
  isSaved,
  isNew,
  onClick,
  onRemoveSavedAd,
  className,
  query,
  location,
  index,
  isPremiumTooltipEnabled,
}) => {
  const url = buildAdUrl(ad)
  const extraProps = getExtraProps(ad, device, isPremiumTooltipEnabled)

  let currentQuery = query
  if (!currentQuery) {
    currentQuery = queryString.parse(location.search)
  }

  return (
    <ListItem
      ad={ad}
      isSaved={isSaved}
      isNew={isNew}
      onRemoveSavedAd={onRemoveSavedAd}
      onClick={onClick}
      url={url}
      className={className}
      query={currentQuery}
      index={index}
      {...extraProps}
    />
  )
}

AdListItem.propTypes = {
  ad: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  query: PropTypes.object,
  isSaved: PropTypes.bool,
  isNew: PropTypes.bool,
  onClick: PropTypes.func,
  onRemoveSavedAd: PropTypes.func,
  className: PropTypes.string,
  index: PropTypes.number,
  isPremiumTooltipEnabled: PropTypes.bool,
}

export default withRouter(withDevice(AdListItem))
